import { Spin } from "antd";
import { useState } from "react";

function ImageWithSpinner({
  item,
  getImageSource,
  handleImageError,
  failedImages,
}) {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "150px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            borderRadius: "4px",
            zIndex: 1,
          }}
        >
          <Spin />
        </div>
      )}
      <img
        src={getImageSource(item)}
        alt={item.product_name}
        className="product-image"
        style={{
          width: "100%",
          height: "150px",
          objectFit: "contain",
          borderRadius: "4px",
        }}
        onLoad={() => setIsLoading(false)}
        onError={(e) => {
          e.target.onerror = null;
          handleImageError(
            item.id,
            failedImages[item.id] !== undefined ? failedImages[item.id] : 0,
            item,
          );
          setIsLoading(false);
        }}
      />
    </>
  );
}

export default ImageWithSpinner;
